import { useEffect, useState } from "react";
import { usePage } from "../contexts/PageProvider";
import AriticleListPage from './AriticleListPage';
import ArticleCategoryPage from './ArticleCategoryPage';
import Box from "@mui/material/Box";
import { Tab, Tabs } from "@mui/material";
import SwipeableViews from "react-swipeable-views";
import { ARTICLE_LIST_URL } from '../contexts/PageProvider';
import axios from "../utils/axios";
import useAuth from "../hooks/useAuth";

const ArticlesPage = () => {
    const {auth} = useAuth();
    const { pageData, setPageData } = usePage();
    if (pageData.url != ARTICLE_LIST_URL) {
        setPageData({url: ARTICLE_LIST_URL, noPadding: true});      
    }
    
    const [tabId, setTabId] = useState(0); 
    const [articles, setArticles] = useState([]);

    const getArticleList = async () => {
        try {
            let config = {
                headers: {
                    'Authorization': `Bearer ${auth?.accessToken}`
                }
            }
            const response = await axios.get("article/", config);
            setArticles(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => { 
        getArticleList();
    }, []);  

   
    let views = [
        <AriticleListPage key="0" {...{articles}}/>,
        <ArticleCategoryPage key="1" {...{articles, getArticleList}}/>
    ]

    let tabs = [
        <Tab key="0" label={"Contenu"} style={{height: '60px', fontWeight: 'bold', textTransform: "none"}} />,
        <Tab key="1" label={"Groupe articles"} style={{height: '60px', fontWeight: 'bold', textTransform: "none"}} />
    ];

    const handleChange = (event, value) => {
        setTabId(value);
    };

    const handleChangeIndex = (index) => {
        setTabId(index);
    }

    return (
        <div>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    sx={{backgroundColor: "white"}}
                    value={tabId}
                    onChange={handleChange}
                    scrollButtons="auto"
                    centered
                >
                    {tabs}
                </Tabs>
            </Box>
            <div style={{padding: "2em"}}> 
                <SwipeableViews
                    axis="x"
                    index={tabId}
                    onChangeIndex={handleChangeIndex}
                >
                    {views}
                </SwipeableViews>
            </div>
        </div>
    )
}

export default ArticlesPage;